import { render, staticRenderFns } from "./InterestCategories.vue?vue&type=template&id=c5169a6e&"
import script from "./InterestCategories.vue?vue&type=script&lang=ts&"
export * from "./InterestCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports